import { FC } from "react";
import "./contractChoiceScreen.scss";

interface Props {
  clientName: string;
  existingCount: number;
  isBusy?: boolean;
  onCreateNew: () => void;
  onBrowseExisting: () => void;
}

/*
    Shown when the engagement has no contract attached: the two ways forward.
*/
const ContractChoiceScreen: FC<Props> = ({
  clientName,
  existingCount,
  isBusy,
  onCreateNew,
  onBrowseExisting,
}) => (
  <div className="contract-choice">
    <div className="contract-choice__icon">
      <i className="bi bi-file-earmark-text" />
    </div>
    <h5 className="contract-choice__title">No contract attached</h5>
    <p className="contract-choice__lead">
      This engagement needs a contract with {clientName} before budget and publishing can be set up.
    </p>

    <div className="contract-choice__options">
      <div className="contract-choice__card contract-choice__card--primary">
        <b>Create new contract</b>
        <small>Start a fresh contract between this client and provider, then attach it here.</small>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={onCreateNew}
          disabled={isBusy}
        >
          Create new
        </button>
      </div>

      <div className="contract-choice__card">
        <b>Select existing</b>
        <small>Attach a contract that already exists between this client and provider.</small>
        <button
          type="button"
          className="btn btn-light btn-sm"
          onClick={onBrowseExisting}
          disabled={isBusy || existingCount === 0}
        >
          {existingCount === 0 ? "None available" : "Browse contracts"}
        </button>
      </div>
    </div>
  </div>
);

export default ContractChoiceScreen;
